module.exports = __webpack_public_path__ + "static/media/header_replay.4afaba33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_replay.jpg
// module id = 408
// module chunks = 0